// extracted by mini-css-extract-plugin
export var form = "_ec-0";